module.exports = __webpack_public_path__ + "static/media/Debut.bc2991cc.png";